import { createGlobalConfig, panoramaClientFactory, PanoramaPlatform } from '@wix/panorama-client-web';
export const INSTALLER_SENTRY_DSN = 'https://902a9b8ea08c461c912b216782ddaf37@sentry-next.wixpress.com/16865';
export const globalConfig = createGlobalConfig();
export const createPanoramaClient = async platform => {
  const sentryOnWindow = typeof window === 'undefined' ? undefined : window.Sentry; // SSR throws error when trying to access window if type was not checked

  const sentry = sentryOnWindow ?? (await import('@sentry/browser').then(Sentry => Sentry));
  const customConfig = {
    baseParams: {
      platform: getValidPanoramaPlatform(platform.toLowerCase()),
      // Mandatory
      fullArtifactId: 'com.wixpress.app-installer-client-api',
      // Mandatory - must be a real artifact id and should include the groupId
      componentId: 'app-installer-client-api' // Mandatory - component naming is up to the project owners (unless they are DevCenter components)
    },
    pluginParams: {
      sentry,
      sentryDsn: INSTALLER_SENTRY_DSN,
      sentryMain: true
    },
    data: {
      platform
    }
  };
  const panoramaFactory = panoramaClientFactory(customConfig).withGlobalConfig(globalConfig);
  const panoramaClient = panoramaFactory.client(customConfig);
  return panoramaClient;
};
const getValidPanoramaPlatform = platform => {
  if (Object.values(PanoramaPlatform).includes(platform)) {
    return platform;
  } else {
    return PanoramaPlatform.Standalone;
  }
};
//# sourceMappingURL=panorama.js.map